import React from 'react';

/**
 * CreditEditor — inline editor for image asset credits.
 *
 * Props:
 *  - credit       : { photographer, source, url, overlayOnImage }
 *  - onChange      : (patch) => void
 *  - className     : optional wrapper class
 */
export default function CreditEditor({ credit = {}, onChange, className = '' }) {
  const update = (field, value) => onChange({ ...credit, [field]: value });

  return (
    <div className={`tw-space-y-2 ${className}`}>
      <div className="tw-text-[10px] tw-font-bold tw-text-zinc-500 tw-uppercase tw-tracking-widest">
        Image Credits
      </div>
      <div>
        <label className="tw-label">Photographer</label>
        <input
          type="text"
          value={credit.photographer || ''}
          onChange={(e) => update('photographer', e.target.value)}
          className="tw-input tw-text-xs"
          placeholder="Photographer name"
        />
      </div>
      <div>
        <label className="tw-label">Source</label>
        <input
          type="text"
          value={credit.source || ''}
          onChange={(e) => update('source', e.target.value)}
          className="tw-input tw-text-xs"
          placeholder="e.g. Unsplash, Getty, AP"
        />
      </div>
      <div>
        <label className="tw-label">Source URL</label>
        <input
          type="url"
          value={credit.url || ''}
          onChange={(e) => update('url', e.target.value)}
          className="tw-input tw-text-xs"
          placeholder="https://..."
        />
      </div>
      <label className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-text-zinc-400 tw-cursor-pointer">
        <input
          type="checkbox"
          checked={credit.overlayOnImage || false}
          onChange={(e) => update('overlayOnImage', e.target.checked)}
          className="tw-rounded tw-border-zinc-600"
        />
        Show credit on image
      </label>
    </div>
  );
}
